module.exports = __webpack_public_path__ + "img/ic_gcar@2x.437eb1d7.png";